import { createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3bba23e7")

_pushScopeId("data-v-3bba23e7")
const _hoisted_1 = { class: "admin-contract-create" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "header" }, [
  /*#__PURE__*/_createVNode("h3", { class: "title" }, "新規契約登録")
], -1)
const _hoisted_3 = { class: "form" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "title" }, "契約種別：", -1)
const _hoisted_5 = { Class: "radio" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  for: "trial",
  Class: "value"
}, " トライアル", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("label", {
  for: "agreement",
  Class: "value"
}, " 本契約", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { class: "title" }, "会社名：", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "title" }, "部署名（任意）：", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "title" }, "ユーザー数上限：", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { class: "title" }, "契約開始日：", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { class: "title" }, "契約終了日：", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { class: "title" }, "備考欄：", -1)
const _hoisted_14 = { class: "apply" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "契約登録", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_InputDate = _resolveComponent("InputDate")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _withDirectives(_createVNode("input", {
          type: "radio",
          id: "trial",
          checked: "checked",
          name: "contractType",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.contract.type = $event)),
          value: 0
        }, null, 512), [
          [_vModelRadio, _ctx.contract.type]
        ]),
        _hoisted_6,
        _withDirectives(_createVNode("input", {
          class: "margin",
          type: "radio",
          name: "contractType",
          id: "agreement",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.contract.type = $event)),
          value: 1
        }, null, 512), [
          [_vModelRadio, _ctx.contract.type]
        ]),
        _hoisted_7
      ]),
      _hoisted_8,
      _withDirectives(_createVNode("input", {
        class: "value",
        type: "text",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.contract.companyName = $event)),
        maxlength: _ctx.consts.maxCompanyNameLength
      }, null, 8, ["maxlength"]), [
        [_vModelText, _ctx.contract.companyName]
      ]),
      _createVNode(_component_ErrorMessage, {
        class: "value",
        messages: _ctx.errorMessages.companyName
      }, null, 8, ["messages"]),
      _hoisted_9,
      _withDirectives(_createVNode("input", {
        class: "value",
        type: "text",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.contract.optionName = $event)),
        maxlength: _ctx.consts.maxOptionNameLength
      }, null, 8, ["maxlength"]), [
        [_vModelText, _ctx.contract.optionName]
      ]),
      _createVNode(_component_ErrorMessage, {
        class: "value",
        messages: _ctx.errorMessages.optionName
      }, null, 8, ["messages"]),
      _hoisted_10,
      _withDirectives(_createVNode("select", {
        class: "value",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.contract.plan = $event))
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.consts.plans, (plan) => {
          return (_openBlock(), _createBlock("option", {
            key: plan,
            value: plan,
            selected: _ctx.contract.plan == plan
          }, _toDisplayString(plan), 9, ["value", "selected"]))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.contract.plan]
      ]),
      _hoisted_11,
      _createVNode(_component_InputDate, {
        class: "value",
        value: _ctx.contract.signed,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.contract.signed = $event))
      }, null, 8, ["value"]),
      _hoisted_12,
      _createVNode(_component_InputDate, {
        class: "value",
        value: _ctx.contract.expire,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.contract.expire = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_ErrorMessage, {
        class: "value",
        messages: _ctx.errorMessages.expire
      }, null, 8, ["messages"]),
      _hoisted_13,
      _withDirectives(_createVNode("textarea", {
        class: "value",
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.contract.describe = $event)),
        maxlength: _ctx.consts.maxContractDescribeLength
      }, null, 8, ["maxlength"]), [
        [_vModelText, _ctx.contract.describe]
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("button", {
        class: "primary-button",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args)))
      }, [
        _hoisted_15
      ])
    ])
  ]))
})